<template>
    <div v-loading="loading" class="alarmClass">
       <div>
        <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
     
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="时间" prop="nursinghomeId">
            <el-date-picker
                v-model="searchForm.dataRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
          </el-form-item>
        </el-col>
      

        <el-col :span="18">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
        <div
          id="heartData_chart_line"
          style="
                    width: 100%;
                    height: 400px;
                    border-top: 1px solid #efefef;
                  "
        ></div>

        <div
          v-if="row.deviceTypeName!='智能床垫'"
          id="bloodtData_chart_line"
          style="
                    width: 100%;
                    height: 400px;
                    border-top: 1px solid #efefef;
                  "
        ></div>


        <div
          v-if="row.deviceTypeName!='智能床垫'"
          id="oxgtData_chart_line"
          style="
                    width: 100%;
                    height: 400px;
                    border-top: 1px solid #efefef;
                  "
        ></div>

        <div
          id="sleepData_chart_line"
          style="
                    width: 100%;
                    height: 400px;
                    border-top: 1px solid #efefef;
                  "
        ></div>
        <div
        v-if="row.deviceTypeName!='智能床垫'"
          id="stepData_chart_line"
          style="
                    width: 100%;
                    height: 400px;
                    border-top: 1px solid #efefef;
                  "
        ></div>
        <div
        v-if="row.deviceTypeName=='智能床垫'"
          id="breathe_chart_line"
          style="
                    width: 100%;
                    height: 400px;
                    border-top: 1px solid #efefef;
                  "
        ></div>
       </div>
     
    </div>
  </template>
    <script>
   import {getSmartDeviceDataHealth } from '@/api/nursingHome/artificalDevice';
 import { option } from './echart.js';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },

      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        searchForm:{
            dataRange:[],
            startTime:'',
            endTime:'',
        },
        heartRate_chart_line:{},
        bloodPressure_chart_line:{},
        bloodOxygen_chart_line:{},
        sleep_chart_line:{},
        step_chart_line:{},
        breathe_chart_line:{},
      };
    },
    created() {
    this.initDate()
    //   this.drawEchart()
    //   this.$nextTick(()=>{
    //         setTimeout(()=>{
    //         this.drawEchart()
    //     })
    //     })
    },
    mounted() {
        this.initData()
      
    },
    watch: {},
    methods: {
      searchClear(){
        this.initDate()
      },
      searchRecord() {
       this. initData()
      },
      initDate(){
        let startTime =this.dayjs().format('YYYY-MM-DD 00:00:00');
        let endTime =this.dayjs().format('YYYY-MM-DD 23:59:59');
        this.searchForm.dataRange =[startTime,endTime]
        this.searchForm.startTime=startTime
        this.searchForm.endTime=endTime
        console.log(startTime,endTime)
      },
    
       initData() {

        if(this.searchForm.dataRange &&this.searchForm.dataRange.length!=0){
          this.searchForm.startTime=this.dayjs(this.searchForm.dataRange[0]).format('YYYY-MM-DD 00:00:00')
        this.searchForm.endTime=this.dayjs(this.searchForm.dataRange[1]).format('YYYY-MM-DD 23:59:59')
        }else{
          this.searchForm.startTime=""
          this.searchForm.endTime=""
        }
        getSmartDeviceDataHealth({
          id: this.row.id,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
        }).then(res=>{
          if(res.msg=="暂无承载数据"){
            option.heart_opt.xAxis.data=[]
            option.heart_opt.series =[]
            option.blood_opt.xAxis.data=[]
            option.blood_opt.series =[]
            option.oxg_opt.xAxis.data=[]
            option.oxg_opt.series =[]
            option.sleep_opt.xAxis.data=[]
            option.sleep_opt.series =[]
            option.step_opt.xAxis.data=[]
            option.step_opt.series =[]
            option.breathe_opt.xAxis.data=[]
            option.breathe_opt.series =[]
            this.drawEchart(this.heartRate_chart_line,'heartData_chart_line',option.heart_opt)
            this.drawEchart(this.sleep_chart_line,'sleepData_chart_line',option.sleep_opt)
            if(this.row.deviceTypeName!='智能床垫'){
              this.drawEchart(this.bloodPressure_chart_line,'bloodtData_chart_line',option.blood_opt)
              this.drawEchart(this.bloodOxygen_chart_line,'oxgtData_chart_line',option.oxg_opt)
              this.drawEchart(this.step_chart_line,'stepData_chart_line',option.step_opt)
            } else {
              this.drawEchart(this.breathe_chart_line,'breathe_chart_line',option.breathe_opt)
            }
            
          }else{
            let heartRate=res.data.heartRate
            if (JSON.stringify(heartRate) != '{}') {
              option.heart_opt.xAxis.data=heartRate.horizontalAxis
          option.heart_opt.series =[]
          option.heart_opt.series.push({
            name:'心率',
            type:'line',
            data:heartRate.dataHeartRate
          })
          this.drawEchart(this.heartRate_chart_line,'heartData_chart_line',option.heart_opt)
          }
          
          let bloodPressure=res.data.bloodPressure
          if (JSON.stringify(bloodPressure) != '{}') {
            option.blood_opt.xAxis.data=bloodPressure.horizontalAxis
          option.blood_opt.series =[]
          option.blood_opt.series.push({
            name:'舒张压',
            type:'line',
            data:bloodPressure.dataDiastolicBloodPressure
          })
          option.blood_opt.series.push({
            name:'收缩压',
            type:'line',
            data:bloodPressure.dataSystolicBloodPressure
          })
          this.row.deviceTypeName != '智能床垫' && this.drawEchart(this.bloodPressure_chart_line,'bloodtData_chart_line',option.blood_opt)
          }
         

          let bloodOxygen=res.data.bloodOxygen
          if (JSON.stringify(bloodOxygen) != '{}') {
            option.oxg_opt.xAxis.data=bloodOxygen.horizontalAxis
          option.oxg_opt.series =[]
          option.oxg_opt.series.push({
            name:'血氧数据',
            type:'line',
            data:bloodOxygen.dataBloodOxygen
          })
          this.row.deviceTypeName != '智能床垫' && this.drawEchart(this.bloodOxygen_chart_line,'oxgtData_chart_line',option.oxg_opt)
          }
          
          let sleep=res.data.sleep
          if (JSON.stringify(sleep) != '{}') {
            option.sleep_opt.xAxis.data=sleep.horizontalAxis
          option.sleep_opt.series =[]
          option.sleep_opt.series.push({
            name:'深度睡眠',
            type:'bar',
            stack: 'total',
            data:sleep.deepSleep
          })
          option.sleep_opt.series.push({
            name:'清醒',
            type:'bar',
            stack: 'total',
            data:sleep.awakeTime
          })
          option.sleep_opt.series.push({
            name:'浅度睡眠',
            type:'bar',
            stack: 'total',
            data:sleep.lightSleep
          })
          this.drawEchart(this.sleep_chart_line,'sleepData_chart_line',option.sleep_opt)
          }
          

          let step=res.data.step
          if (JSON.stringify(step) != '{}') {
            option.step_opt.xAxis.data=step.horizontalAxis
          option.step_opt.series =[]
          option.step_opt.series.push({
            name:'计步数据',
            type:'line',
            data:step.dataStep
          })
          if(this.row.deviceTypeName!='智能床垫'){
            this.drawEchart(this.step_chart_line,'stepData_chart_line',option.step_opt)
            }
        
          }

          let breathe = res.data.breath;
          if (JSON.stringify(breathe) != '{}') {
            option.breathe_opt.xAxis.data = breathe.horizontalAxis;
            option.breathe_opt.series = [];
            option.breathe_opt.series.push({
              name: '呼吸',
              type: 'line',
              data: breathe.dataBreath,
            });
            this.row.deviceTypeName == '智能床垫' && this.drawEchart(this.breathe_chart_line, 'breathe_chart_line', option.breathe_opt);
          }
          
          }
          
        })
       
      },
      drawEchart(vm,id,option) {
        vm= echarts.init(document.getElementById(id));
        vm.clear()
        vm.setOption(option);
    },
    },
  };
  </script>
    <style scoped>
  
  </style>
    